<div class="content-container" role="main" [attr.aria-busy]="loading ? 'true' : 'false'" aria-live="assertive">
  @if (mainTheme !== 'custom') {
    <id-card>
      <ng-container *ngTemplateOutlet="userChoiceContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="userChoiceContent"></ng-container>
    </div>
  }

  <ng-template #userChoiceContent>
    <div class="flex flex-column flex-align-center">
      <h1 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }}">
        {{ getAuthTypeText() }}
      </h1>
      <h2 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mb-3">
        {{ clientInfo?.organizationName }}
      </h2>
      <h3 class="{{ mainTheme !== themeType.Custom ? 'ids-heading-l' : 'custom-heading-l' }} ids-mb-5">
        {{ getTypeText() }}
      </h3>
    </div>
    @if (!loading) {
      <form [formGroup]="filterForm" class="full-width">
        <div class="ids-mb-3">
          <id-input>
            <label class="hide-label">Filtrera</label>
            <input type="search" autocomplete="off" placeholder="filtrera..." formControlName="filter" />
          </id-input>
        </div>
      </form>

      <div class="desktop-view">
        <div class="is-scrollable flex flex-column">
          <table id="userChoiceTable" aria-describedby="Användarval" class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th
                  scope="col"
                  (click)="setSortCol('employeeHsaId')"
                  (keyup.space)="setSortCol('employeeHsaId')"
                  (keyup.enter)="setSortCol('employeeHsaId')"
                  class="is-clickable"
                  [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                  <div class="flex flex-row align-center">
                    <div class="table-header ids-mr-1" tabindex="0">
                      HSA-id
                      <span
                        class="ids-ml-1"
                        [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                        @if (tableSortColumn === 'employeeHsaId') {
                          @if (sortReverse) {
                            <span
                              aria-hidden="true"
                              class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                          } @else {
                            <span
                              aria-hidden="true"
                              class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                          }
                        }
                      </span>
                    </div>
                  </div>
                </th>

                @if (tableType === TableType.COMMISSION) {
                  <th
                    scope="col"
                    id="titleCommissionName"
                    (click)="setSortCol('commissionName')"
                    (keyup.space)="setSortCol('commissionName')"
                    (keyup.enter)="setSortCol('commissionName')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Namn
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'commissionName') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>

                  <th
                    scope="col"
                    id="titleHealthCareUnitName"
                    (click)="setSortCol('healthCareUnitName')"
                    (keyup.space)="setSortCol('healthCareUnitName')"
                    (keyup.enter)="setSortCol('healthCareUnitName')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Vårdenhet
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'healthCareUnitName') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>

                  <th
                    scope="col"
                    id="titleCommissionPurpose"
                    (click)="setSortCol('commissionPurpose')"
                    (keyup.space)="setSortCol('commissionPurpose')"
                    (keyup.enter)="setSortCol('commissionPurpose')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Syfte
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'commissionPurpose') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>

                  <th
                    scope="col"
                    id="titleHealthCareProviderName"
                    (click)="setSortCol('healthCareProviderName')"
                    (keyup.space)="setSortCol('healthCareProviderName')"
                    (keyup.enter)="setSortCol('healthCareProviderName')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Vårdgivare
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'healthCareProviderName') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>
                }

                @if (tableType === TableType.ORGANIZATION) {
                  <th
                    scope="col"
                    id="titleOrganizationHsaId"
                    (click)="setSortCol('organizationHsaId')"
                    (keyup.space)="setSortCol('organizationHsaId')"
                    (keyup.enter)="setSortCol('organizationHsaId')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Organisationens HSA-id
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'organizationHsaId') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>

                  <th
                    scope="col"
                    id="titleOrganizationName"
                    (click)="setSortCol('organizationName')"
                    (keyup.space)="setSortCol('organizationName')"
                    (keyup.enter)="setSortCol('organizationName')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Organisationsnamn
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'organizationName') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>

                  <th
                    scope="col"
                    id="titleOrganizationIdentifier"
                    (click)="setSortCol('organizationIdentifier')"
                    (keyup.space)="setSortCol('organizationIdentifier')"
                    (keyup.enter)="setSortCol('organizationIdentifier')"
                    class="is-clickable"
                    [attr.aria-sort]="sortReverse ? 'descending' : 'ascending'">
                    <div class="flex flex-row align-center">
                      <div class="table-header ids-mr-1" tabindex="0">
                        Organisationsnummer
                        <span
                          class="ids-ml-1"
                          [attr.aria-label]="sortReverse ? 'Sorterat fallande' : 'Sorterat stigande'">
                          @if (tableSortColumn === 'organizationIdentifier') {
                            @if (sortReverse) {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-down ids-icon--xs ids-icon--color-preset-1"></span>
                            } @else {
                              <span
                                aria-hidden="true"
                                class="ids-icon-arrow-up ids-icon--xs ids-icon--color-preset-1"></span>
                            }
                          }
                        </span>
                      </div>
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              <tr
                tabindex="0"
                (click)="makeUserChoice(userChoiceItem)"
                (keyup.space)="makeUserChoice(userChoiceItem)"
                (keyup.enter)="makeUserChoice(userChoiceItem)"
                class="is-clickable selectable"
                *ngFor="
                  let userChoiceItem of userChoices
                    | filterUserChoices: filterForm.value.filter
                    | userChoiceSort: tableSortColumn : sortReverse
                ">
                <td>{{ userChoiceItem.employeeHsaId }}</td>

                @if (tableType === TableType.COMMISSION) {
                  <td>{{ userChoiceItem.commissionName }}</td>
                  <td>{{ userChoiceItem.healthCareUnitName }}</td>
                  <td>{{ userChoiceItem.commissionPurpose }}</td>
                  <td>{{ userChoiceItem.healthCareProviderName }}</td>
                }

                @if (tableType === TableType.ORGANIZATION) {
                  <td>{{ userChoiceItem.organizationHsaId }}</td>
                  <td>{{ userChoiceItem.organizationName }}</td>
                  <td>{{ userChoiceItem.organizationIdentifier }}</td>
                }
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mobile-view">
        <div class="flex flex-column">
          <id-card
            class="ids-mb-3"
            *ngFor="
              let userChoiceItem of userChoices
                | filterUserChoices: filterForm.value.filter
                | userChoiceSort: tableSortColumn : sortReverse
            ">
            <div class="flex flex-center ids-mb-3">
              <h3 class="ids-heading-xs">{{ userChoiceItem.employeeHsaId }}</h3>
            </div>

            @if (tableType === TableType.COMMISSION) {
              <dl class="horizontal ids-mb-5">
                <dt>Namn</dt>
                <dd>{{ userChoiceItem.commissionName }}</dd>
                <dt>Vårdenhet</dt>
                <dd>{{ userChoiceItem.healthCareUnitName }}</dd>
                <dt>Syfte</dt>
                <dd>{{ userChoiceItem.commissionPurpose }}</dd>
                <dt>Vårdgivare</dt>
                <dd>{{ userChoiceItem.healthCareProviderName }}</dd>
              </dl>
            }

            @if (tableType === TableType.ORGANIZATION) {
              <dl class="horizontal ids-mb-5">
                <dt>Organisationens HSA-id</dt>
                <dd>{{ userChoiceItem.organizationHsaId }}</dd>
                <dt>Organisationsnamn</dt>
                <dd>{{ userChoiceItem.organizationName }}</dd>
                <dt>Organisationsnummer</dt>
                <dd>{{ userChoiceItem.organizationIdentifier }}</dd>
              </dl>
            }
            <div class="flex flex-justify-end">
              <id-button>
                <button (click)="makeUserChoice(userChoiceItem)">Välj</button>
              </id-button>
            </div>
          </id-card>
        </div>
      </div>
    }
    @if (loading) {
      <div class="flex flex-center margin-50">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }
  </ng-template>
</div>
